const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

export const analyticsEnabled = Boolean(GA_MEASUREMENT_ID)

/**
 * Loads gtag.js and configures it with automatic pageview tracking turned
 * off — Inertia is a single-page app after the initial load, so gtag's
 * automatic pageview (tied to a full page load) would only ever fire once.
 * trackPageview() is called manually instead, on the initial load and on
 * every subsequent Inertia navigation.
 */
export function initAnalytics() {
  if (!analyticsEnabled) return

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() { window.dataLayer.push(arguments) }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.gtag('js', new Date())
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false })
}

export function trackPageview(path) {
  if (!analyticsEnabled || typeof window.gtag !== 'function') return

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
  })
}
